var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{class:['dd-back-top', {'is-show': _vm.isShow}],attrs:{"type":"top"},nativeOn:{"click":function($event){return _vm.backTop($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }